import axios from "axios";
import React, { useEffect, useState } from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Table } from "../../../components/CustomPaginations";
import { dateCol, tableStyle } from "../../../components/TableStyle";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import { ProjectReport_API } from "./ProjectReport_API";
import FilterationBar from "./FilterationBar";
import { Col, Row } from "reactstrap";
import { Redirect } from "react-router-dom";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function ProjectReport() {
	let token,
		empId,
		empDepartment,
		empDesignation = null;
	const defaultSorted = [
		{
			dataField: "projectStartedDate",
			order: "desc",
		},
	];
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [employeeList, setEmployeeList] = useState(null);
	const [supervisorList, setSupervisorList] = useState(null);
	const [projectList, setProjectList] = useState(null);
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const [selectedSupervisor, setSelectedSupervisor] = useState(null);
	const [selectedProject, setSelectedProject] = useState(null);
	const [projectReportData, setProjectReportData] = useState([]);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [tokenHeader, setTokenHeader] = useState(null);
	const [pageNum, setPageNum] = useState(1);
	const [pagerData, setPagerData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const getColumns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "projectName",
			text: "Project Name",
			sort: true,
		},
		{
			dataField: "projectStartedDate",
			text: "Project Started Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "employeeCurrentSupervisor",
			text: "Employee Current Supervisor",
			sort: true,
		},
		{
			dataField: "employeeProjectSupervisor",
			text: "Employee Project Supervisor",
			sort: true,
		},
	];
	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		const headers = {
			Authorization: `Bearer ${token}`,
		};
		if (
			empDepartment === "3" ||
			empDepartment === "9" ||
			empDepartment === "4" ||
			empDepartment === "5" ||
			empDesignation.toString() === "4" ||
			empId.toString() === "180" || empId==="33"
		) {
			axios
				.get(`${ProjectReport_API.GetEmployeeList}?isActive=true`, {
					headers: headers,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const employeeList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						setEmployeeList(
							employeeList.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
						employeeList.unshift({ value: 0, label: "All" });
						setSelectedEmployee(employeeList[0]);
					}
				});
		} else {
			axios
				.get(`${ProjectReport_API.GetSupervisorsEmployeesList}`, {
					headers: headers,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const employeeList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						setEmployeeList(
							employeeList.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
						employeeList.unshift({ value: 0, label: "All" });
						setSelectedEmployee(employeeList[0]);
					}
				});
		}

		axios
			.get(`${ProjectReport_API.GetSupervisorList}`, { headers: headers })
			.then(({ status, data }) => {
				if (status === 200) {
					const supervisorList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					setSupervisorList(
						supervisorList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
					supervisorList.unshift({ value: 0, label: "All" });
					setSelectedSupervisor(supervisorList[0]);
				}
			});
		axios
			.get(`${ProjectReport_API.GetProjectList}?isActive=true`, {
				headers: headers,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const projectList = data.projects;
					setProjectList(
						projectList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
					projectList.unshift({ value: 0, label: "All" });
					setSelectedProject(projectList[0]);
				}
			});
		axios
			.get(
				`${
					ProjectReport_API.GetProjectReportData
				}PageNumber=${pageNum}&PageSize=${pageSize}&EmployeeId=${0}&SupervisorId=${0}&ProjectId=${0}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{ headers: headers }
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setProjectReportData(res.data.projectReport);
				}
			});

		setTokenHeader(headers);
	}, []);

	const updateTableDataOnFilteration = (empId, supId, projId) => {
		setIsLoading(true);
		axios
			.get(
				`${ProjectReport_API.GetProjectReportData}PageNumber=${pageNum}&PageSize=${numberOfItemsPerPage}&EmployeeId=${empId}&SupervisorId=${supId}&ProjectId=${projId}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setProjectReportData(res.data.projectReport);
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					ProjectReport_API.GetProjectReportData
				}PageNumber=${1}&PageSize=${PageSize}&EmployeeId=${
					selectedEmployee.value
				}&SupervisorId=${
					selectedSupervisor ? selectedSupervisor.value : 0
				}&ProjectId=${selectedProject.value}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setProjectReportData(res.data.projectReport);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${
				ProjectReport_API.GetProjectReportData
			}PageNumber=${page}&PageSize=${numberOfItemsPerPage}&EmployeeId=${
				selectedEmployee.value
			}&SupervisorId=${
				selectedSupervisor ? selectedSupervisor.value : 0
			}&ProjectId=${
				selectedProject.value
			}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				ProjectReport_API.GetProjectReportData
			}PageNumber=${page}&PageSize=${numberOfItemsPerPage}&EmployeeId=${
				selectedEmployee.value
			}&SupervisorId=${
				selectedSupervisor ? selectedSupervisor.value : 0
			}&ProjectId=${selectedProject.value}&SortBy=${sortBy.dataField}_${
				sortBy.order
			}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: tokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setProjectReportData(res.data.projectReport);
					}
				});
		}
	};
	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios({
			url: `${ProjectReport_API.ExportToExcel}?EmployeeId=${
				selectedEmployee.value
			}&SupervisorId=${
				selectedSupervisor ? selectedSupervisor.value : 0
			}&ProjectId=${selectedProject.value}`,
			method: "GET",
			responseType: "blob",
			headers: tokenHeader,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "ProjectReport.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDepartment = userDetails.department;
				empDesignation = userDetails.designation;
				empId = userDetails.id;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ||
					userDetails.designation.toString() === "7" ||
					userDetails.empRole.includes("4") ||
					userDetails.department.toString() === "4" ? (
					<div className="container-fluid pl-3 pr-3">
						<Header title="Project Report" headerBorder={true} />

						<FilterationBar
							employeeList={employeeList}
							selectedEmployee={selectedEmployee}
							onEmployeeChange={(value) => {
								setSelectedEmployee(value);
								updateTableDataOnFilteration(
									value.value,
									selectedSupervisor
										? selectedSupervisor.value
										: 0,
									selectedProject.value
								);
							}}
							supervisorList={supervisorList}
							selectedSupervisor={selectedSupervisor}
							onSupervisorChange={(value) => {
								setSelectedSupervisor(value);
								updateTableDataOnFilteration(
									selectedEmployee.value,
									value.value,
									selectedProject.value
								);
							}}
							projectList={projectList}
							selectedProject={selectedProject}
							onProjectChange={(value) => {
								setSelectedProject(value);
								updateTableDataOnFilteration(
									selectedEmployee.value,
									selectedSupervisor
										? selectedSupervisor.value
										: 0,
									value.value
								);
							}}
						/>

						<Row>
							<Col className="d-flex justify-content-end">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={showBtnLoading}
									disabled={
										!projectReportData.length ||
										showBtnLoading
									}
								/>
							</Col>
						</Row>

						<PaginationProvider
							pagination={paginationFactory({
								custom: true,
								totalSize: pagerData ? pagerData.TotalCount : 0,
								page: pageNum,
								sizePerPage: numberOfItemsPerPage,
								paginationSize: numberOfItemsPerPage,
							})}
						>
							{({ paginationProps, paginationTableProps }) => {
								return (
									<Table
										inputValue={""}
										keyField={"id"}
										columns={getColumns}
										items={projectReportData}
										tableStyle={tableStyle}
										paginationProps={paginationProps}
										paginationTableProps={
											paginationTableProps
										}
										onTablePageChange={handleTableChange}
										defaultSorted={defaultSorted}
										showFeedback={false}
										tableLoader={isLoading}
										SearchBar={() => {
											return null;
										}}
										pagerData={pagerData}
										receiveData={(PageSize) => {
											receiveData(PageSize);
										}}
									/>
								);
							}}
						</PaginationProvider>
					</div>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ProjectReport;
